import { currentUser } from "modules/utilities/utility";
import api from "../../../../api/index"
import secureLocalStorage from "react-secure-storage";


export function todayEngagement(sd, ed, tag = null) {
    if (tag) return api.get(`v2/engagements?rep_id=${secureLocalStorage.getItem('id')}&start_date=${sd}T18:30:00.000Z&end_date=${ed}T18:29:59.999Z&state=active&tag=${encodeURIComponent(tag)}`);
    return api.get(`v2/engagements?rep_id=${secureLocalStorage.getItem('id')}&start_date=${sd}T18:30:00.000Z&end_date=${ed}T18:29:59.999Z&state=active`);
}

export function tempLeadEng(sd, ed){
    return api.get(`v2/engagements?start_date=${sd}T18:30:00.000Z&end_date=${ed}T18:29:59.999Z&state=active&temporary_rep_id=${secureLocalStorage.getItem('id')}`);
}

export function tempEngagement(tag = null) {
    if (tag) return api.get(`v2/engagements?temporary_rep_id=${secureLocalStorage.getItem('id')}&state=active&tag=${encodeURIComponent(tag)}`)
    return api.get(`v2/engagements?temporary_rep_id=${secureLocalStorage.getItem('id')}&state=active`)
}

